import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import BtnBlock from './components/BtnBlock';
import NameField from './components/NameField';
import ModalWindows from './components/ModalWindows';
import {
	CreateGameDeveloperContext,
	ICreateGameDeveloperContext,
} from './createDeveloperModalContext/createDeveloperModalState/createDeveloperModalContext';
import { preventDefaultForEnterKey } from 'utils/helpers';
import classNames from 'classnames';
import style from './CreateDeveloperModal.module.scss';

interface ICreateDeveloperModal {
	isVisible: boolean;
}

const CreateDeveloperModal: React.FC<ICreateDeveloperModal> = ({ isVisible }) => {
	const { setDataForSubmit, changeTypeOfModalWindow, changeName, name } =
		useContext<ICreateGameDeveloperContext>(CreateGameDeveloperContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ name });
	}, [name]);

	const submit = () => {
		setDataForSubmit({
			name,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={containerClasses} data-test="CreateDeveloperModal">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.wrapper}>
					<div className={style.content}>
						<Text
							className={style.heading}
							translationNameSpace="form"
							translationKey="creatingDeveloperHeading"
							size="xxl"
							weight="bold"
						/>
						<NameField changeName={changeName} />
					</div>
					<BtnBlock />
				</div>
			</Form>
			<ModalWindows />
		</div>
	);
};

export default React.memo(CreateDeveloperModal);
